module.exports = __webpack_public_path__ + "assets/link5.1421e39c.svg";